// src/features/user/userSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import HttpService from '../services/HttpServices';
const apiService =   HttpService
export const logout = createAsyncThunk(
    'user/logout',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.post('/public/dummy/auth/logout'); // Use the Axios instance for the request
            // Check response.data for success if necessary
            // Axios automatically throws an error for non-2xx responses, so you might not need to explicitly throw here
            return; // Optionally return some payload
        } catch (error) {
            return rejectWithValue(error.response?.data?.error || error.message);
        }
    }
);

export const userSlice = createSlice({
    name: 'user',
    initialState: {
        // Define your initial state, including isAuthenticated, etc.
        isAuthenticated: false,
    },
    reducers: {
        // Synchronous reducers go here
    },
    extraReducers: (builder) => {
        builder
            .addCase(logout.fulfilled, (state) => {
                // Handle the fulfilled state
                state.isAuthenticated = false;
                // Perform other state updates as needed
            })
        // You can also handle pending and rejected states as needed
    },
});

// Don't forget to export the reducer and any actions
export const userReducer = userSlice.reducer;